import axiosInstance from 'src/config/axios.config';
import { API_ENDPOINTS } from 'src/config/api.config';

// ----------------------------------------------------------------------

export interface User {
  id: string;
  name: string;
  username: string;
  password?: string;
  accountNonExpired: boolean;
  accountNonLocked: boolean;
  credentialsNonExpired: boolean;
  companyId?: string;
  authorities: string[];
  enabled: boolean;
}

export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  message: string;
}

// ----------------------------------------------------------------------

/**
 * Change password for the currently authenticated user
 *
 * Uses the secure POST /api/auth/change-password endpoint which:
 * - Works for ALL authenticated users (MANAGER, ADMIN, SUPER_ADMIN, USER)
 * - Validates the old password before changing
 * - Enforces 8 character minimum for new password
 * - Prevents password reuse
 *
 * @param oldPassword - The user's current password
 * @param newPassword - The new password to set (minimum 8 characters)
 * @throws Error if password change fails
 */
export async function changePassword(oldPassword: string, newPassword: string): Promise<void> {
  try {
    const requestBody: ChangePasswordRequest = {
      oldPassword,
      newPassword,
    };

    await axiosInstance.post<ChangePasswordResponse>(
      `${API_ENDPOINTS.AUTH}/change-password`,
      requestBody
    );
  } catch (error: any) {
    console.error('Password change error:', error);

    // Handle specific error codes from backend
    const errorCode = error.response?.data?.errorCode;
    const message = error.response?.data?.message;

    if (errorCode === 'INVALID_OLD_PASSWORD') {
      throw new Error(message || 'Mevcut sifre yanlis');
    } else if (errorCode === 'INVALID_PASSWORD') {
      throw new Error(message || 'Yeni sifre gereksinimleri karsilamiyor');
    } else {
      throw new Error(message || 'Sifre degistirme basarisiz oldu');
    }
  }
}
